module.exports = __webpack_public_path__ + "img/43.bff01184.gif";